module.exports = __webpack_public_path__ + "static/media/jarvis-logo-full.5b6f01a0.svg";